import { luscinia } from '../../luscinia';
import { Calendar, EventSourceInput } from '@fullcalendar/core';

export class TimeLineFilterManager {
    container: HTMLElement;
    calendar: Calendar;
    calendarBaseUrl: string;
    form: HTMLFormElement;

    constructor(container: HTMLElement, calendar: Calendar) {
        this.container = container;
        this.calendar = calendar;
        this.calendarBaseUrl = `/timeline/${this.container.dataset.tableName}`;
        this.form = container.querySelector('form');
    }
    init() {
        this.initFormControls();
        this.initSelect2s();
        this.form.addEventListener('filter change', () => {
            this.updateCalendarEventSource();
        });
    }
    private updateCalendarEventSource() {
        const filters = this.getUrlSearchParams();
        const newEventSourceUrl = `${this.calendarBaseUrl}?${filters.toString()}`;
        const newEventSource: EventSourceInput = {
            url: newEventSourceUrl,
            method: 'GET',
        };
        this.calendar.removeAllEventSources();
        this.calendar.addEventSource(newEventSource);
    }

    private getUrlSearchParams(): URLSearchParams {
        const filters = new URLSearchParams();
        const formControls = this.form.elements;
        for (var i = 0, len = formControls.length; i < len; ++i) {
            const formControl = formControls[i];
            if (formControl instanceof HTMLInputElement) {
                if (!formControl.name) {
                    continue;
                }
                switch (formControl.type) {
                    case 'checkbox':
                        filters.append(formControl.name, formControl.checked ? 'true' : 'false');
                        break;
                    case 'text':
                        if (formControl.value) {
                            filters.append(formControl.name, formControl.value);
                        }
                        break;
                    default:
                        break;
                }
                if (formControl.classList.contains('ajax-select')) {
                    if (formControl.value !== '' && formControl.value !== null) {
                        filters.append(formControl.name, formControl.value);
                    }
                }
            }
        }
        return filters;
    }
    private initSelect2s(): void {
        const select2s = this.container.querySelectorAll('input.ajax-select') as NodeListOf<HTMLInputElement>;
        select2s.forEach((select2) => {
            luscinia.initializeAjaxSelect2($(select2), {
                placeholder: select2.dataset.placeholder,
                allowClear: true,
            });
            $(select2).on('change', () => {
                this.form.dispatchEvent(new Event('filter change'));
            });
        });
    }
    private initFormControls(): void {
        const formControls = this.form.elements;
        for (var i = 0, len = formControls.length; i < len; ++i) {
            formControls[i].addEventListener('change', (e) => {
                const changeEvent = new Event('filter change');
                this.form.dispatchEvent(changeEvent);
            });
        }
    }
}